import { MANUAL_ENTRY_TYPES } from "./ManualEntryConstants";

export const getManualEntryType = (manualEntryTypeId) => {
  return MANUAL_ENTRY_TYPES.find((type) => type.id === manualEntryTypeId);
};
